//component imports
import ActiveLink from "src/components/layouts/ActiveLink";
import Skeleton from "src/components/elements/Skeleton";

//util imports
import urlGenerator from "src/utils/urlGenerator";

const CategoriesListing = (props) => {
  const categoriesData = props.categories;
  return (
    <>
      {categoriesData && categoriesData.docs && categoriesData.docs.length > 0
        ? categoriesData.docs.map((obj) => {
          const { name, icon, _id, slug } = obj;
          return (
            <li key={_id}>
              <ActiveLink
                activeClassName=""
                href={urlGenerator.categoryDir()}
                as={urlGenerator.categoryLink(slug)}
              >
                <img src={icon ? icon : 'images/categoryDefault.png'} alt={name} />
                <p className="text-capitalize">{name}</p>
              </ActiveLink>

            </li>
          );
        })
        : Array(6)
          .fill()
          .map((item, index) => (
            <li key={index}>
              <Skeleton height={78} width={78} />
              <p>
                <Skeleton width={150} />
              </p>
            </li>
          ))}
    </>
  );
};

CategoriesListing.displayName = "CategoriesListing";

export default CategoriesListing;
